import React from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import {AccentColorOptions, useBreakpointOnly} from 'epic-ue-theme';
import {CmsButtonProps, GridContainer, Typography, VerticalSpacer} from '../../elements';
import {AnimateOnViewWrap} from '../../wraps/animation/AnimateOnViewWrap';

const Styled = styled.div`
    && {
        .download-options-grid-container {
            ${(p) => p.theme.breakpoints.down('md')} {
                padding: 0;
            }
        }
        .download-options-card,
        .card-separator {
            padding-top: 0;
        }
        .card-separator {
            position: relative;
            .h4 {
                position: absolute;
                top: -8px;
                ${(p) => p.theme.breakpoints.up('sm')} {
                    left: calc(50% - 12px);
                }
            }
        }
    }
`;

interface DownloadCardUE5Props {
    title?: string;
    description?: string;
    link?: CmsButtonProps;
    accentColor?: AccentColorOptions;
}

export interface DownloadOptionsProps {
    cards?: DownloadCardUE5Props[];
    cardSeparator?: string;
    accentColor?: AccentColorOptions;
    downloadCards: React.ReactNode[];
}

export const DownloadOptions = ({
    cards = [],
    cardSeparator = 'or',
    downloadCards
}: DownloadOptionsProps): JSX.Element => {
    const isXs = useBreakpointOnly('xs');

    return (
        <Styled>
            <AnimateOnViewWrap translateY={50}>
                <GridContainer className="download-options-grid-container">
                    <Grid
                        container
                        alignItems={'flex-start'}
                        justifyContent={'flex-start'}
                        spacing={3}>
                        {cards[0].title || cards[0].description ? (
                            <Grid
                                item
                                xs={12}
                                sm={5}
                                md={4}
                                lg={5}
                                className="download-options-card">
                               {downloadCards[0]}
                                <VerticalSpacer variant="custom" downSmSpacing={4} spacing={0} />
                            </Grid>
                        ) : (
                            ''
                        )}
                        {cardSeparator && !isXs ? (
                            <Grid item sm={2} lg={1} className="card-separator">
                                <Typography variant="h4" big>
                                    {cardSeparator}
                                </Typography>
                            </Grid>
                        ) : (
                            ''
                        )}
                        {cards[1].title || cards[1].description ? (
                            <Grid
                                item
                                xs={12}
                                sm={5}
                                md={4}
                                lg={5}
                                className="download-options-card">
                                {downloadCards[1]}
                            </Grid>
                        ) : (
                            ''
                        )}
                    </Grid>
                </GridContainer>
            </AnimateOnViewWrap>
        </Styled>
    );
};
